import React, { Component } from "react";

import { CCard, CCardBody, CLink, CButton } from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import { linkify } from "../../../../utils/string";

import "./style.css";

class OccurrenceMe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notices: [],
      loading: true
    };
  }

  friendlyDate(date) {
    const dt = new Date(date);
    const hj = new Date();
    const months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ];

    if (dt.getFullYear() !== hj.getFullYear()) {
      return `${dt.getDate()} de ${
        months[dt.getMonth()]
      } de ${dt.getFullYear()}`;
    }

    return `${dt.getDate()} de ${
      months[dt.getMonth()]
    }, às ${`00${dt.getHours()}`.slice(-2)}:${`00${dt.getMinutes()}`.slice(
      -2
    )}`;
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  group(myArray) {
    let months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ];

    let groups = myArray.reduce((r, o) => {
      let m = o.created_at.split("-")[1];
      let y = o.created_at.split("-")[0];

      let extra = parseInt(y) !== new Date().getFullYear() ? ` de ${y}` : "";

      r[`${m}-${y}`]
        ? r[`${m}-${y}`].data.push(o)
        : (r[`${m}-${y}`] = {
            group: months[parseInt(m) - 1] + extra,
            data: [o]
          });

      return r;
    }, {});

    let result = Object.keys(groups).map(k => groups[k]);

    return result;
  }

  componentDidMount() {
    const params = {
      for: this.props.user.id
      // group_id: this.props.user.user_roles[0].group_id
    };

    axios
      .get(`${URL.api}communication/occurrence/list`, {
        params,
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState({
            notices: this.group(resp.data.data),
            loading: false
          });
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  render() {
    return (
      <>
        <div className="d-flex">
          <div className="flex-1 d-flex justify-content-end align-items-center">
            <Breadcrumb current={this.props.currentRoute} />
            {["G", "U"].includes(this.props.general.active_roles.type) && (
              <div className="flex-1 d-flex justify-content-end align-items-center">
                <CButton
                  color="primary"
                  onClick={() => this.props.history.push("/occurrence/form")}
                  style={{ minWidth: "160px" }}
                >
                  <i className="fa fa-plus mr-2"></i>Adicionar Tipo
                </CButton>
              </div>
            )}
            {["G", "E"].includes(this.props.general.active_roles.type) && (
              <div className="flex-1 d-flex justify-content-end align-items-center">
                <CButton
                  color="primary"
                  onClick={() => this.props.history.push("/occurrence/form")}
                  style={{ minWidth: "180px", marginLeft: "10px" }}
                >
                  <i className="fa fa-plus mr-2"></i>Nova Ocorrência
                </CButton>
              </div>
            )}
          </div>
        </div>
        {this.state.loading ? (
          <Loading />
        ) : this.state.notices && this.state.notices.length > 0 ? (
          this.state.notices.map(month => (
            <>
              <h4 className="mb-4">{month.group}</h4>
              <div className="card-columns mb-4">
                {month.data.map(notice => (
                  <CLink
                    // to={notice.id ? `/classroom/${notice.id}` : "#"}
                    // key={notice.id}
                    className="not-link"
                  >
                    <CCard key={notice.id} className="notice-card">
                      <CCardBody>
                        <div>
                          <div className="d-flex align-items-center">
                            <div className="d-block w-100">
                              <div className="text-muted">
                                {this.friendlyDate(notice.created_at)}
                              </div>
                            </div>
                          </div>
                          <div
                            className="mt-2"
                            style={{ fontSize: "1rem", fontWeight: "bold" }}
                          >
                            {notice.referral}
                          </div>
                        </div>
                        {notice.description && (
                          <div className="mt-2">
                            {linkify(notice.description)}
                          </div>
                        )}
                      </CCardBody>
                    </CCard>
                  </CLink>
                ))}
              </div>
              <ProtectedRoute routeId={this.props.currentRoute} />
            </>
          ))
        ) : (
          <div className="d-flex align-items-center justify-content-center m-3">
            Nenhum aviso encontrado
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(OccurrenceMe);
